import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col, Row, Badge } from 'reactstrap';
import { H5, H6 } from '../../../AbstractElements';
import ReactApexChart from 'react-apexcharts';
import { Activity, TrendingUp, Users, Clock } from 'react-feather';

const UserQLTActivities = ({ usersQLT = [], loading }) => {
  const [chartData, setChartData] = useState({
    series: [{ name: 'Activities', data: [] }],
    options: {
      chart: { type: 'bar', height: 350, toolbar: { show: false } },
      colors: ['#7366ff', '#f73164', '#51bb25'],
      xaxis: { categories: [] },
      yaxis: { title: { text: 'Số lượng' } },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
        }
      },
      dataLabels: { enabled: false }
    }
  });

  // Tính toán hoạt động user theo thời gian
  const generateActivityData = () => {
    if (!usersQLT || usersQLT.length === 0) {
      return {
        series: [{ name: 'New Users', data: [] }, { name: 'Active Users', data: [] }, { name: 'Total Users', data: [] }],
        categories: []
      };
    }

    const categories = ['Week 1', 'Week 2', 'Week 3', 'Week 4'];
    const totalUsers = usersQLT.length;
    
    const newUsersData = [totalUsers * 0.2, totalUsers * 0.4, totalUsers * 0.7, totalUsers].map(Math.floor);
    const activeUsersData = [totalUsers * 0.1, totalUsers * 0.3, totalUsers * 0.6, totalUsers * 0.8].map(Math.floor);
    const totalUsersData = newUsersData.map((_, index) => 
      newUsersData.slice(0, index + 1).reduce((sum, val) => sum + val, 0)
    );

    setChartData({
      series: [
        { name: 'New Users', data: newUsersData },
        { name: 'Active Users', data: activeUsersData },
        { name: 'Total Users', data: totalUsersData }
      ],
      options: {
        ...chartData.options,
        xaxis: { ...chartData.options.xaxis, categories }
      }
    });
  };

  useEffect(() => {
    generateActivityData();
  }, [usersQLT]);

  // Tính toán thống kê hoạt động
  const getActivityStats = () => {
    if (!usersQLT || usersQLT.length === 0) {
      return {
        totalActivities: 0,
        todayActivities: 0,
        weeklyGrowth: 0,
        activeUsers: 0
      };
    }

    const totalActivities = usersQLT.length * 3; // Giả định mỗi user có 3 hoạt động
    const todayActivities = Math.floor(totalActivities * 0.1);
    const weeklyGrowth = 15; // 15% tăng trưởng
    const activeUsers = usersQLT.filter(user => user.isActive !== false).length;

    return { totalActivities, todayActivities, weeklyGrowth, activeUsers };
  };

  const activityStats = getActivityStats();
  const statsData = [
    {
      title: 'Total Activities',
      value: activityStats.totalActivities,
      icon: Activity,
      color: 'primary'
    },
    {
      title: 'Today Activities',
      value: activityStats.todayActivities,
      icon: Clock,
      color: 'success'
    },
    {
      title: 'Weekly Growth',
      value: `${activityStats.weeklyGrowth}%`,
      icon: TrendingUp,
      color: 'info'
    },
    {
      title: 'Active Users',
      value: activityStats.activeUsers,
      icon: Users,
      color: 'warning'
    }
  ];

  if (loading) {
    return (
      <Col xxl="6" className="box-col-6">
        <Card>
          <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
            <div className="text-center">
              <p>Đang tải hoạt động user...</p>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

  return (
    <Col xxl="6" className="box-col-6">
      <Card>
        <CardHeader className="card-no-border">
          <H5>User Activities</H5>
        </CardHeader>
        <CardBody>
          <Row className="g-3 mb-4">
            {statsData.map((item, index) => {
              const Icon = item.icon;
              return (
                <Col key={index} xs="6" sm="6">
                  <div className="d-flex align-items-center">
                    <div className={`bg-${item.color} rounded d-flex align-items-center justify-content-center me-3`} 
                         style={{ width: '40px', height: '40px' }}>
                      <Icon size={20} className="text-white" />
                    </div>
                    <div>
                      <span className="f-light f-w-500 f-12 d-block">{item.title}</span>
                      <H6 attrH6={{ className: 'mb-0' }}>
                        <Badge color={item.color} className="badge-sm">
                          {item.value}
                        </Badge>
                      </H6>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>

          <div className="chart-container">
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="bar"
              height={250}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserQLTActivities;

